function Home() {
  return (
    <header className="App-header">
      <img src="/mwml-logo-bw.svg" className="App-logo" alt="Made With Monster Love" />
      <p className="company-description">
        Software made with ❤️ by <a href="https://thefuntastic.com/">@TheFuntastic</a> (Peter Cardwell-Gardner)
      </p>

      <section className="game-section">
        <h2>Games</h2>
        <p className="game-description">
          Cadence is a minimalist puzzle game about solving circuits to create music.
        </p>



        <a href="https://store.steampowered.com/app/362800/Cadence/" target="_blank" >
        <img src="/store_capsule_main_1232x706.png" alt="Cadence Game Cover" className="game-cover" />
        </a>

        {/* <div className="video-container">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/dQw4w9WgXcQ"
            title="Cadence - Game Trailer"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen>
          </iframe>
        </div> */}

        <p>Cadence is not a rhythm game, but a zen music sandbox that rewards curiosity and problem solving.</p>

        <p>Coming soon to PC and iOS.</p>

        <iframe src="https://store.steampowered.com/widget/362800/" frameBorder="0" width="760" height="190" className="steam-widget"></iframe>

        {/* <div className="store-links">
          <a
            href="https://store.steampowered.com/app/362800/Cadence/"
            target="_blank"
            rel="noopener noreferrer"
            className="store-button steam-button"
          >
            Steam
          </a>
          <a
            href="https://apps.apple.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="store-button appstore-button"
          >
            App Store
          </a>
        </div> */}
      </section>
      <section className="footer-section">
        <p className="game-description"> Copyright © 2025 Made With Monster Love Ltd</p>
        </section>.
    </header>
  );
}

export default Home;
